import { FETCH_UPGRADES, FETCH_UPGRADES_FAIL, FETCH_LOADING } from './types';
import { SLACK_WEBHOOKS } from '../config';
import axios from 'axios';
import { SlackWebhook } from './utils';

/**
 * Get upgrades for linked trips to be bundled
 *
 *
 * @param {string} tourId - product tour id
 * @param {string} currency - iso currency (GBP, AUD, USD, CAD)
 * @param {number} endStopID - end stop id (optional if a hoho itinerary)
 * @param {string} departureDate - departure date (if on booking summary)
 */
export function FetchUpgrades(tourId, currency, departureDate = "", endStopId = ""){

  const hasEndStopId = (endStopId !== "") ? `/${endStopId}` : "";
  const hasDepartureDate = (departureDate !== "") ? `/${departureDate}` : "";
  const URL = `${process.env.REACT_APP_PRODUCTS_API}${tourId}/upgrades${hasDepartureDate}${hasEndStopId}?api_token=${process.env.REACT_APP_API_TOKEN}&currency=${currency}`;
  const config = { withCredentials: true};

  return (dispatch) => {
    dispatch({type:FETCH_LOADING , payload:true});
    return new Promise((resolve, reject) => {
      axios.get(URL, config)
      .then((response) => {
        dispatch({type:FETCH_UPGRADES, payload:response.data});
        resolve();
      })
      .catch((err)=>{
        console.error(err);
        dispatch(SlackWebhook(SLACK_WEBHOOKS.errors, {'text':'Botch! Upgrade API (GET) - ' + URL + " " + err}));
        dispatch({type:FETCH_UPGRADES_FAIL});
        dispatch({type:FETCH_LOADING , payload:true});
        reject();
      })
    })
  }

}



// WEBPACK FOOTER //
// ./src/actions/upgrades.js